
<div class="login_sheet">
    <img src="../../../../assets/images/Logo_Orange_colorless.png" class="logo_login" alt="">
    <form action="" method="post">
            <div class="notification error" *ngIf="sent">
                       {{'Email has been sent' | translate}}
             </div>
            <div class="notification error" *ngIf="errMsg">
                  {{ errMsg | translate}}
             </div>
          <div class="form_group">
                <input type="text" #email class="with_email_icon" placeholder="{{'Email' | translate}}">
          </div>
          <div class="form_group">
                <input type="submit" (click)="onSubmit(email.value)" [disabled]="loading" [value]="loading? 'loading...' : 'ENTER'">
          </div>
      <div class="powered_by">{{'Copyright' | translate}} d.light {{currentYear}}</div>
          <div class="powered_by"><a [routerLink]="['/login']">{{'Back' | translate}}</a></div>
    </form>
</div>

